export default __webpack_public_path__ + "static/media/190629_190332_IMG_9254 (1).a2cc90f6.jpg";